import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

// Componente para exibir a data na barra inferior
const DateWidget = () => {
  const [today, setToday] = useState(new Date());
  const [config, setConfig] = useState({
    formato: 'DD/MM/AAAA'
  });
  
  // Carregar configurações
  useEffect(() => {
    const loadConfig = () => {
      const savedConfig = localStorage.getItem('painelChamada_configCompleta');
      if (savedConfig) {
        try {
          const parsedConfig = JSON.parse(savedConfig);
          if (parsedConfig.data) {
            setConfig(parsedConfig.data);
          }
        } catch (error) {
          console.error('Erro ao carregar configurações da data:', error);
        }
      }
    };
    
    loadConfig();
    
    // Atualizar a data à meia-noite
    const updateDate = () => setToday(new Date());
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    const timeUntilMidnight = tomorrow - now;
    
    const timer = setTimeout(updateDate, timeUntilMidnight);
    
    // Monitorar alterações nas configurações
    const configObserver = () => {
      window.addEventListener('storage', (event) => {
        if (event.key === 'painelChamada_configCompleta') {
          loadConfig();
        }
      });
    };
    
    configObserver();
    
    return () => {
      clearTimeout(timer);
      window.removeEventListener('storage', configObserver);
    };
  }, []);
  
  // Formatar a data com base nas configurações
  const getFormattedDate = () => {
    switch (config.formato) {
      case 'DD/MM/AA':
        return format(today, 'dd/MM/yy');
      case 'DD/MM/AAAA':
        return format(today, 'dd/MM/yyyy');
      case 'MM/DD/AA':
        return format(today, 'MM/dd/yy');
      case 'MM/DD/AAAA':
        return format(today, 'MM/dd/yyyy');
      case 'DD de MMMM de AAAA':
        return format(today, "dd 'de' MMMM 'de' yyyy", { locale: ptBR });
      default:
        return format(today, 'dd/MM/yyyy');
    }
  };
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'white' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <CalendarTodayIcon sx={{ mr: 2, fontSize: 28 }} />
        <Typography variant="h3" sx={{ fontWeight: 'light' }}>
          {getFormattedDate()}
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ mt: 1, fontSize: '0.8rem' }}>
        DATA ATUAL
      </Typography>
    </Box>
  );
};

export default DateWidget; 